import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { formatCurrency } from '@angular/common';
import { OrderformFascade } from '../fascades/orderform.fascade';
import { Subscription } from 'rxjs';
import { OrderformPrice } from '@orderform/widgets';

@Pipe({
  name: 'price',
  // eslint-disable-next-line @angular-eslint/no-pipe-impure
  pure: false, // need to be false, if currency changes and value is the same, pipe does not render with new currency!
})
export class PricePipe implements PipeTransform {
  private _subscription: Subscription;
  private _latestValue: string;

  constructor(private _orderformFascade: OrderformFascade, private _cd: ChangeDetectorRef) {}

  transform(value: string | number | OrderformPrice): string {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }

    this._subscription = this._orderformFascade.globalSettings$.subscribe((settings) => {
      if (typeof value === 'object') {
        value = settings.is_vat_shown ? value['net'] : value['gross'];
      }
      this._latestValue = formatCurrency(
        +value,
        settings.language,
        settings.currency_symbol,
        settings.currency_code,
        this._getFormatString(+value)
      );

      this._cd.markForCheck();
    });

    return this._latestValue;
  }

  private _getFormatString(value: number): string {
    const isWholeNumber = Number.isInteger(value);

    /**
     * Decimal formatting ignoring product's is_show_cent_amount_part_shown setting:
     * Ensures add-ons/shipping prices with decimals always show trailing zeros (23.8 → 23.80).
     */
    return isWholeNumber ? '1.0-0' : '1.2-2';
  }
}
